import React from 'react';
import { ErrorContentLayout } from 'layout';
import { useDossierContext } from './dossier.context';
import { LoaderDotted } from '@isyc-react/form/modules/base';
// TODO i18n
export const DossierStatusManager = props => {
    const { children } = props;
    const { loading, error } = useDossierContext();
    if (loading) {
        return (React.createElement("div", { className: 'vh-100 d-flex justify-content-center align-items-center mb-4' },
            React.createElement(LoaderDotted, null)));
    }
    if (error) {
        return (React.createElement(ErrorContentLayout, null,
            React.createElement("h1", { className: 'text-primary' }, "Erreur de dossier"),
            React.createElement("p", null, "Impossible d'obtenir les donn\u00E9es du dossier")));
    }
    return React.createElement(React.Fragment, null, children);
};
